import { render, staticRenderFns } from "./appModality.vue?vue&type=template&id=3c2dff7b&scoped=true"
import script from "./appModality.vue?vue&type=script&lang=js"
export * from "./appModality.vue?vue&type=script&lang=js"
import style0 from "./appModality.vue?vue&type=style&index=0&id=3c2dff7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2dff7b",
  null
  
)

export default component.exports